import { Components, Theme } from "@mui/material/styles";

import { Palette } from "../../theme/palette";

declare module "@mui/material/Chip" {
  interface ChipPropsSizeOverrides {
    large: boolean;
  }

  interface ChipPropsVariantOverrides {
    pill: boolean;
  }
}

export const chipTheme: Partial<Pick<Components<Theme>, "MuiChip">> = {
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 3,

        "& .MuiChip-deleteIcon": {
          width: "14px !important",
          height: "14px !important",
          marginLeft: 0,

          "&:hover": {
            color: Palette.WHITE,
          },
        },
      },
      filled: {
        backgroundColor: Palette.SECONDARY[6],
      },
      outlined: {
        backgroundColor: Palette.TRANSPARENT,
      },
      filledPrimary: {
        backgroundColor: Palette.PRIMARY["dark/50"],
        color: Palette.PRIMARY.light,

        "& .MuiChip-deleteIcon": {
          color: Palette.PRIMARY.light,
        },
      },
      outlinedPrimary: {
        border: "none",
        boxShadow: `inset 0 0 0 0.5px ${Palette.PRIMARY["dark"]}`,
        color: Palette.PRIMARY.light,

        "& .MuiChip-deleteIcon": {
          color: Palette.PRIMARY.light,
        },
      },
      filledSecondary: {
        backgroundColor: Palette.SECONDARY["5/50"],
        color: Palette.SECONDARY["2/75"],

        "& .MuiChip-deleteIcon": {
          color: Palette.SECONDARY["2/75"],
        },
      },
      outlinedSecondary: {
        border: "none",
        boxShadow: `inset 0 0 0 0.5px ${Palette.SECONDARY["3/50"]}`,
        color: Palette.SECONDARY[3],

        "& .MuiChip-deleteIcon": {
          color: Palette.SECONDARY[3],
        },
      },
      // @ts-ignore - TODO - refactor: `ts-ignore` must be removed, migrate this component to the new design and MUI7
      filledSuccess: {
        backgroundColor: Palette.SUCCESS["dark/50"],
        color: Palette.SUCCESS["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.SUCCESS["dark"],
        },
      },
      outlinedSuccess: {
        border: "none",
        boxShadow: `inset 0 0 0 0.5px ${Palette.SUCCESS["dark/50"]}`,
        color: Palette.SUCCESS["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.SUCCESS["dark"],
        },
      },
      filledWarning: {
        backgroundColor: Palette.WARNING["dark/50"],
        color: Palette.WARNING["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.WARNING["dark"],
        },
      },
      outlinedWarning: {
        border: "none",
        boxShadow: `inset 0 0 0 0.5px ${Palette.WARNING["dark/50"]}`,
        color: Palette.WARNING["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.WARNING["dark"],
        },
      },
      filledError: {
        backgroundColor: Palette.ERROR["dark/50"],
        color: Palette.ERROR["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.ERROR["dark"],
        },
      },
      outlinedError: {
        border: "none",
        boxShadow: `inset 0 0 0 0.5px ${Palette.ERROR["dark/50"]}`,
        color: Palette.ERROR["main"],

        "& .MuiChip-deleteIcon": {
          color: Palette.ERROR["dark"],
        },
      },
      sizeSmall: {
        height: 20,
        fontSize: 12,

        "& .MuiChip-icon": {
          width: "12px !important",
          height: "12px !important",
          marginLeft: "5px",
        },
      },
      sizeMedium: {
        height: 24,
        fontSize: 13,

        "& .MuiChip-icon": {
          width: "13px !important",
          height: "13px !important",
          marginLeft: "7px",
          marginRight: "-4px",
        },
      },
      sizeLarge: {
        height: 28,
        fontSize: 14,

        "& .MuiChip-icon": {
          width: "14px !important",
          height: "14px !important",
          marginLeft: "7px",
          marginRight: "-4px",
        },
      },
      labelSmall: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
      labelMedium: {
        padding: "4px 8px",
      },
      labelLarge: {
        padding: "4px 8px",
      },
    },
    variants: [
      {
        props: {
          variant: "pill",
        },
        style: {
          textTransform: "uppercase",
          color: Palette.SECONDARY[8],
          height: "16px", // Note: may need to be adjusted for different sizes. Waiting for full Figma design.

          "& .MuiChip-label": {
            padding: "0 4px",
          },
        },
      },
    ],
  },
};
